export enum XpressPriorityType {
    None = 0,
    Low = 1,
    Lowest = 2,
    Medium = 3,
    High = 4,
    Highest = 5
}
